import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=207a0aaf&"
import script from "./CreateGroup.js?vue&type=script&lang=js&"
export * from "./CreateGroup.js?vue&type=script&lang=js&"
import style0 from "./CreateGroup.vue?vue&type=style&index=0&id=207a0aaf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports